import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';
import { AreaTypeEnum } from './area.vm';

export interface CreateAreaBody {
  id: string;
  name: string;
  type: AreaTypeEnum;
}

export const createArea = async (warehouseId: string, body: CreateAreaBody, callback: CallbackObject<void>) => {
  try {
    await instance.post(`/warehouse/warehouses/${warehouseId}/areas`, body);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
